export default __webpack_public_path__ + "static/media/AnimalGame_03.02bf9788.png";